// モーダルの開閉機能を各トリガにバインドする
import modalToggle from '../lib/modal';

document.addEventListener('turbolinks:load', () => {
  const toggleElements = document.querySelectorAll('[data-modal-toggle]');
  if (!toggleElements) return;

  for (let i = 0; i < toggleElements.length; i += 1) {
    const toggleElement = toggleElements[i];

    const targetModal = document.querySelector(toggleElement.getAttribute('data-modal-toggle'));
    toggleElement.addEventListener('click', () => modalToggle(targetModal));
  }
});
